import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import copy from 'copy-to-clipboard'
import classNames from 'classnames'

import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import { Body, Item } from 'components/Utils/Menu/layout'
import { PenIcon, DeleteIcon, LinkIcon, MoreIcon } from 'components/Utils/Icons'
import { selectors as ChannelSelectors } from 'data/channels'

import { providesCommentEditionControls } from '../dataSync'

import RoutesHelper from 'helpers/RoutesHelper'
import { COMMENTS } from 'data/ui/UrlPanelTypes'
import { canManageChannel as canManageChannelHelper } from 'remote/channels/roles'

const POPOVER_WIDTH = 188

class Options extends React.Component {
  render() {
    const {
      onReply,
      commentId,
      threadId,
      noteId,
      isHovered,
      canManageChannel,
      isCurrentUserCommentAuthor,
    } = this.props

    const userCanEdit = isCurrentUserCommentAuthor
    const userCanDelete = canManageChannel || isCurrentUserCommentAuthor

    return (
      <div
        className={classNames(
          'color-mode-elevated',
          'flexbox flexbox-align-end',
          'radius-normal',
          isHovered
            ? 'background-shade-100 shadow--large'
            : 'background-transparent'
        )}
        ref={ref => (this.body = ref)}
      >
        {onReply && (
          <div
            className="flexbox flexbox-centered padding-small margin-right-smaller pointer shade-20 shade-10-on-hover font-size-normal font-weight-medium"
            style={{
              opacity: isHovered ? 1 : 0,
              height: 24,
            }}
            onClick={onReply}
          >
            Reply
          </div>
        )}
        <PopoverOnClick
          position="bottom"
          align="start"
          content={({ closePopover }) => {
            return (
              <Body
                style={{
                  width: POPOVER_WIDTH,
                }}
              >
                {userCanEdit && (
                  <Item
                    icon={<PenIcon size={16} />}
                    action={() => {
                      closePopover()
                      this.props.onCommentEdit()
                    }}
                  >
                    Edit
                  </Item>
                )}

                {userCanDelete && (
                  <Item
                    icon={<DeleteIcon size={16} />}
                    action={() => {
                      closePopover()
                      this.props.archiveComment({
                        input: { commentId },
                      })
                    }}
                  >
                    Delete
                  </Item>
                )}

                <Item
                  icon={<LinkIcon size={16} />}
                  action={() => {
                    closePopover()
                    const commentLink = RoutesHelper.absoluteNoteShow({
                      noteId,
                      options: COMMENTS,
                      threadId,
                      commentId,
                    })
                    copy(commentLink)
                  }}
                >
                  Copy link
                </Item>
              </Body>
            )
          }}
        >
          <div
            className="flexbox flexbox-centered padding-small pointer shade-20 shade-10-on-hover"
            style={{
              opacity: isHovered ? 1 : 0,
              height: 24,
            }}
          >
            <MoreIcon size={12} className="rotate-clockwise" />
          </div>
        </PopoverOnClick>
      </div>
    )
  }
}

export default compose(
  connect(state => {
    const channel = ChannelSelectors.getActiveChannel(state)
    const canManageChannel = canManageChannelHelper({ channel })

    return { canManageChannel }
  }),
  providesCommentEditionControls
)(Options)
